<template>
	<table class="table table-responsive table-hover admin-table">
		<thead>
			<tr>
				<th>N°</th>
				<th>Nombre</th>
				<th>Email</th>
				<th>N° de Compras</th>
				<th>Empresa</th>
				<th></th>
			</tr>
		</thead>
		<tbody>
			<tr class="clickable-row" v-for="item in list" v-if="user.id != item.id">
				<td>{{ $index + 1 }}</td>
				<td>{{ item.name }}</td>
				<td>{{ item.email }}</td>
				<td>{{ item.total_purchases }}</td>
				<td>{{ (item.is_wholesaler == '1') ? 'Si' : 'No' }}</td>
				<td>
					<i class="fa fa-pencil" aria-hidden="true" v-link="{ path: url + item.id }"></i>
					<i class="fa fa-trash" aria-hidden="true" @click="remove(item)"></i>
				</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
export default {
	// ------ PROPS ------

	props: ['list', 'url', 'remove'],

	// ------ DATA ------
	
	data() {
		return {};
	},

	vuex: {
		getters: {
			user: state => state.current_user
		}
	},

	// ------ RENDER ------

	computed: {
		render_list() {
			return this.list;
		},

		render_url() {
			return this.url;
		}
	}
}
</script>


// WEBPACK FOOTER //
// Admin-table-users.vue?3bb82166